import { useEffect, useState } from "preact/hooks";
import { apiJson, getCreds, setCreds } from "./api";
import type { Tenant } from "./api";
import { Login } from "./components/Login";
import { Tenants } from "./components/Tenants";
import { Urls } from "./components/Urls";
import { Analytics } from "./components/Analytics";

type Tab = "tenants" | "urls" | "analytics";

export function App() {
  const [authed, setAuthed] = useState(!!getCreds());
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [selectedCode, setSelectedCode] = useState<string | null>(null);
  const [tab, setTab] = useState<Tab>("tenants");
  const [err, setErr] = useState<string | null>(null);

  async function reload() {
    try {
      const data = await apiJson<{ tenants: Tenant[] }>(`/api/tenants`);
      setTenants(data.tenants);
      if (!selectedCode && data.tenants[0]) setSelectedCode(data.tenants[0].code);
      setErr(null);
    } catch (e) {
      setErr(String(e));
    }
  }

  useEffect(() => {
    if (authed) reload();
  }, [authed]);

  if (!authed) return <Login onAuth={() => setAuthed(true)} />;

  const selected = tenants.find((t) => t.code === selectedCode) ?? null;

  return (
    <div class="app">
      <header class="top">
        <h1>ICMAA Admin</h1>
        <nav>
          <button
            class={tab === "tenants" ? "active" : ""}
            onClick={() => setTab("tenants")}
          >
            Tenants
          </button>
          <button
            class={tab === "urls" ? "active" : ""}
            onClick={() => setTab("urls")}
            disabled={!selected}
          >
            URLs
          </button>
          <button
            class={tab === "analytics" ? "active" : ""}
            onClick={() => setTab("analytics")}
            disabled={!selected}
          >
            Analytics
          </button>
        </nav>
        {tenants.length > 0 && tab !== "tenants" && (
          <select
            value={selectedCode ?? ""}
            onChange={(e) =>
              setSelectedCode((e.target as HTMLSelectElement).value)
            }
          >
            {tenants.map((t) => (
              <option value={t.code} key={t.code}>
                {t.code} — {t.short_domain}
              </option>
            ))}
          </select>
        )}
        <button
          onClick={() => {
            setCreds(null);
            setAuthed(false);
          }}
        >
          Sign out
        </button>
      </header>

      <main>
        {err && <div class="error">{err}</div>}
        {tab === "tenants" && <Tenants tenants={tenants} reload={reload} />}
        {tab === "urls" && selected && <Urls tenant={selected} />}
        {tab === "analytics" && selected && <Analytics tenant={selected} />}
      </main>
    </div>
  );
}
